const validateFetchResponse = response => {
  if (!response.ok) {
    throw new Error("HTTP error " + response.status)
  }
  return response.json()
}

export function fetchActivityDetail(activityId) {
  return fetch(`/activity/details/${activityId}`).then(validateFetchResponse)
}
